import PDMPlpSOP from "@tw/product-discovery-merchandizing-cra/lib/plp/sop/sop-master-nextjs";
import PageWrapper from "../wrappers/page-wrapper";

PDMPlpSOP.domainName = "product-discovery";

export default PageWrapper(PDMPlpSOP);
